import { useEffect, useState } from 'react';
import { useIsMounted } from 'usehooks-ts';

import { getReferencesUnavailableDates } from '@lt/api/dist/methods/references/types';
import { useGetApiClient } from '../../../context/apiContext';

export const useFetchUnavailableDates = ({
  toCountry,
  fromCity,
  searchType,
}: Partial<getReferencesUnavailableDates>) => {
  const [unavailableDates, setUnavailableDates] = useState<Date[]>([]);
  const [arrivalDatesDict, setArrivalDatesDict] = useState<Record<string, string[]>>({});
  const [loading, setLoading] = useState(false);
  const isMounted = useIsMounted();
  const api = useGetApiClient();

  useEffect(() => {
    setLoading(true);
    const fetchDepartures = async () => {
      if (toCountry && fromCity && searchType && isMounted() && api) {
        const { dates, arrivalDates } = await api.getReferencesUnavailableDates({
          toCountry,
          fromCity,
          searchType,
        });

        if (isMounted()) {
          setUnavailableDates(dates);
          setArrivalDatesDict(arrivalDates);
        }
      } else {
        setUnavailableDates([]);
      }
    };

    fetchDepartures()
      .catch(console.error)
      .finally(() => {
        setLoading(false);
      });
  }, [toCountry, fromCity, searchType, isMounted]);

  return {
    unavailableDates,
    arrivalDatesDict,
    loading,
  };
};
